import { useState } from "react";

const containerStyle = {
  display: "flex",
  flexGrow: 1
};

const style = {
  flexGrow: 1,
  color: "#202020",
  border: "solid 1px #E0E0E0",
  borderTopLeftRadius: 10,
  borderBottomLeftRadius: 10,
  outline: 0,
  padding: 9,
  fontFamily: "Pretendard",
  fontSize: 16
};

const buttonStyle = {
  cursor: "pointer",
  backgroundColor: "#FFFFFF",
  color: "#202020",
  border: "solid 1px #E0E0E0",
  borderTopRightRadius: 10,
  borderBottomRightRadius: 10,
  marginLeft: -1,
  fontFamily: "Pretendard",
  fontSize: 15,
  fontWeight: 600,
  width: 48
};

const disabledStyle = {
  cursor: "default",
  backgroundColor: "#E0E0E0",
  color: "#B0B0B0"
};

export function TextInput(props) {
  const [ value, setValue ] = useState(props.defaultValue ?? "");
  const [ disabled, setDisabled ] = useState(true);
  const onChange = (e) => { setValue(e.target.value); setDisabled(false); props.onChange && props.onChange(e); };
  const onClick = (e) => { props.onClick && props.onClick(e, value, setDisabled); };

  return (<>
    <div style={ containerStyle }>
      <input id={ props.id } type="text" style={ style } value={ value } onChange={ onChange }/>
      <button style={ { ...buttonStyle, ...(disabled && disabledStyle) } } onClick={ onClick } disabled={ disabled }>저장</button>
    </div>
  </>);
}
